import { useEffect, useState } from 'react'

export const usePopup = ({
  key,
  isSession
}: {
  key: string
  isSession?: boolean
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState<boolean | undefined>()
  useEffect(() => {
    const isResultPagePopupClosed = Boolean(
      isSession ? sessionStorage.getItem(key) : localStorage.getItem(key)
    )
    setIsPopupOpen(!isResultPagePopupClosed)
  }, [])
  return {
    isPopupOpen,
    setIsPopupOpen
  }
}
